import React, { useState, useEffect } from 'react';
import { collection, addDoc, serverTimestamp, onSnapshot, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import './NotificacionesADMIN.css';

export default function NotificacionesAdmin() {
  const [mensaje, setMensaje] = useState('');
  const [audiencia, setAudiencia] = useState('global');
  const [usuariosEspecificos, setUsuariosEspecificos] = useState('');
  const [notificaciones, setNotificaciones] = useState([]);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'notificaciones'), (snapshot) => {
      const notifs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNotificaciones(notifs);
    });
    return () => unsub();
  }, []);

  const handleEnviar = async (e) => {
    e.preventDefault();
    if (!mensaje.trim()) return alert('El mensaje no puede estar vacío');

    setEnviando(true);

    try {
      let data = {
        mensaje: mensaje.trim(),
        timestamp: serverTimestamp(),
        global: audiencia === 'global'
      };

      if (audiencia === 'usuarios') {
        data.usuarios = usuariosEspecificos
          .split(',')
          .map(u => u.trim())
          .filter(u => u.length > 0);
        if (data.usuarios.length === 0) {
          alert('Debes poner al menos un UID de usuario válido.');
          setEnviando(false);
          return;
        }
      }

      await addDoc(collection(db, 'notificaciones'), data);
      setMensaje('');
      setUsuariosEspecificos('');
      setAudiencia('global');
      alert('Notificación enviada ✅');
    } catch (err) {
      console.error(err);
      alert('Error enviando notificación');
    }
    setEnviando(false);
  };

  const handleBorrar = async (id) => {
    if (!window.confirm('¿Seguro que quieres borrar esta notificación?')) return;
    try {
      await deleteDoc(doc(db, 'notificaciones', id));
      alert('Notificación borrada 🗑️');
    } catch (err) {
      console.error(err);
      alert('Error borrando notificación');
    }
  };

  return (
    <div className="notificaciones-container">
      <header className="notificaciones-header">
        <h2>Panel de Notificaciones (Admin)</h2>
      </header>

      <form onSubmit={handleEnviar} className="notificaciones-form">
        <textarea
          className="notificaciones-input"
          value={mensaje}
          onChange={e => setMensaje(e.target.value)}
          placeholder="Escribe el mensaje aquí..."
          rows={4}
          required
          disabled={enviando}
        />

        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
          <label style={{ marginRight: '1rem' }}>
            <input
              type="radio"
              value="global"
              checked={audiencia === 'global'}
              onChange={() => setAudiencia('global')}
              disabled={enviando}
            />{' '}
            Para todos los clientes
          </label>

          <label>
            <input
              type="radio"
              value="usuarios"
              checked={audiencia === 'usuarios'}
              onChange={() => setAudiencia('usuarios')}
              disabled={enviando}
            />{' '}
            Para usuarios específicos (UIDs separados por coma)
          </label>
        </div>

        {audiencia === 'usuarios' && (
          <input
            type="text"
            placeholder="UID1, UID2, UID3..."
            value={usuariosEspecificos}
            onChange={e => setUsuariosEspecificos(e.target.value)}
            disabled={enviando}
            className="notificaciones-input"
          />
        )}

        <button type="submit" disabled={enviando} className="notificaciones-send-btn">
          {enviando ? 'Enviando...' : 'Enviar Notificación'}
        </button>
      </form>

      <h3 style={{ marginTop: '2rem' }}>Notificaciones existentes:</h3>

      {notificaciones.length === 0 ? (
        <p>No hay notificaciones creadas aún.</p>
      ) : (
        <ul className="notificaciones-list">
          {notificaciones.map(({ id, mensaje, timestamp, global, usuarios }) => (
            <li key={id} className="notificacion-item">
              <span className="notificacion-text">{mensaje}</span>
              <span className="notificacion-fecha">
                {timestamp?.toDate().toLocaleString() || 'Fecha no disponible'}
              </span>
              <span className="notificacion-fecha" style={{ fontStyle: 'italic', marginLeft: '10px' }}>
                {global ? 'Para todos' : `Usuarios: ${usuarios?.join(', ')}`}
              </span>
              <div className="notificacion-actions">
                <button onClick={() => handleBorrar(id)}>Borrar</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
